import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-melding-klacht',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconMeldingKlacht {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="m3.22 14.37.12.03c.56.13 1.12.2 1.66.2 2.07 0 4.08-.86 5.53-2.36l1.6-1.58 1.37 1.36a7.68 7.68 0 0 0 3.07 2.09l.22.08-.07-.23C15.83 11.04 13.07 9 10.03 9s-5.97 2.16-6.77 5.25l-.03.11h-.01Zm-.18 2.06v.16c.31 3.6 3.38 6.41 6.98 6.41s6.76-2.89 6.98-6.58v-.1l-.65-.13a9.545 9.545 0 0 1-4.15-2.77l-.09-.1-.09.1c-1.79 2.06-4.36 3.24-7.03 3.24-.59 0-1.19-.07-1.8-.19l-.15-.03ZM34 0H24c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h1v3.57c0 .47.6.68.89.31L29 13.99h5c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2m-4.28 10.72c-.19.19-.43.28-.72.28s-.54-.09-.72-.28c-.19-.19-.28-.43-.28-.72s.09-.53.28-.72c.19-.19.43-.28.72-.28s.54.09.72.28c.19.19.28.43.28.72s-.09.53-.28.72M29 8c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1m-9 22v5c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1v-5c0-2.76 2.24-5 5-5h10c2.76 0 5 2.24 5 5"/>
</svg>

    );
  }
}
